/**
 * Country 2 alpha codes as per the ISO 3166 standard https://en.wikipedia.org/wiki/List_of_ISO_3166_country_codes
 */
export enum CountryCode {
  SouthAfrica = 'ZA',
  Namibia = 'NA',
}
